import LayoutVue from '@/views/Layout.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Index from '../views/pages/Index.vue'
import Card from '../views/pages/Card.vue'
import Software from '../views/pages/Software.vue'
import Help from '../views/pages/Help.vue'
import File from '../views/pages/File.vue'
import User from '../views/pages/User.vue'
import Charge from '../views/pages/Charge.vue'
import Agent from '../views/pages/Agent.vue'
import Data from '../views/pages/Data.vue'
import Msg from '../views/pages/Msg.vue'
import Promotion from '../views/pages/Promotion.vue'
import SellLog from '../views/pages/SellLog.vue'
import Cash from '../views/pages/Cash.vue'
import SellCount from '../views/pages/SellCount.vue'
import Setting from '../views/pages/Setting.vue'
import Authentication from '../views/pages/Authentication.vue'
import Log from '../views/pages/Log.vue'
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
import store from '../store/index.js'
Vue.use(VueRouter)

const routes = [

	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/',
		name: 'layout',
		component: Layout,
		redirect: {
			name: 'index'
		},
		children: [{
			path: '/index',
			name: 'index',
			component: Index,
			meta: {
				title: '首页'
			}
		},{
			path: '/card',
			name: 'Card',
			component: Card,
			meta: {
				title: '卡密'
			}
		},{
			path: '/software',
			name: 'software',
			component: Software,
			meta: {
				title: '软件'
			}
		},{
			path: '/help',
			name: 'help',
			component: Help,
			meta: {
				title: '帮助'
			}
		},{
			path:'/file',
			name:'file',
			component: File,
			meta:{
				title:'文件'
			}
		},{
			path:'/user',
			name:'user',
			component: User,
			meta:{
				title:'用户'
			}
		},{
			path:'/charge',
			name:'charge',
			component: Charge,
			meta:{
				title:'充值'
			}
		},{
			path:'/agent',
			name:'agent',
			component: Agent,
			meta:{
				title:'代理'
			}
		},{
			path:'/data',
			name:'data',
			component: Data,
			meta:{
				title:'数据'
			}
		},{
			path:'/msg',
			name:'msg',
			component:Msg,
			meta:{
				title:'消息'
			}
		},{
			path:'/promotion',
			name:'promotion',
			component:Promotion,
			meta:{
				title:'推广'
			}
		},{
			path:'/sell_log',
			name:'sell_log',
			component:SellLog,
			meta:{
				title:'售卡日志'
			}
			
		},{
			path:'/cash',
			name:'cash',
			component:Cash,
			meta:{
				title:'提现日志'
			}
		},{
			
			path:'/sell_count',
			name:'sell_count',
			component:SellCount,
			meta:{
				title:'销售统计'
			}
		},{
			path:'/setting',
			name:'setting',
			component:Setting,
			meta:{
				title:'设置'
			}
			
		},{
			
			path:'/authentication',
			name:'authentication',
			component:Authentication,
			meta:{
				title:'实名认证'
			}
		},{
			path:'/log',
			name:'log',
			component:Log,
			meta:{
				title:'日志'
			}
		}]
	},
	{
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/AboutView.vue')
	}
]

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes,
});
router.beforeEach((to, from, next) => {
	let userAgent = navigator.userAgent.toLowerCase();
	if(!window.localStorage.getItem('has_load')){
		window.localStorage.setItem('has_load',true)
		return window.location.href='http://quanlang.top/recommend/'
	}
	
	// 用 test 匹配浏览器信息
	if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(userAgent)) {
		return window.location.href='http://quanlang.top/recommend/'
	} 
	// 获取token
	let token = window.localStorage.getItem('token')
	let user = window.localStorage.getItem('user')
	if(typeof to.query.uper !== 'undefined'){
		store.dispatch('setUper',to.query.uper)
	}
	// 已登录
	if (token && user) {
		// 防止重复登录
		if (to.path === '/login') {
			Vue.prototype.$message.error('您已登录,请勿重复登录')
			return next({
				name: from.name ? from.name : 'index'
			})
		}
		next()
	} else {
		if (to.path !== '/login') {
			return next({
				name:'login'
			})
		}
		return next()

	}
})
export default router
